import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../utils/auth';
import PasswordInput from '../components/PasswordInput';
import '../styles/auth.css';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [needs2fa, setNeeds2fa] = useState(false);
  const [challenge, setChallenge] = useState('');
  const [code, setCode] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }
      if (data.requires_2fa) {
        setNeeds2fa(true);
        setChallenge(data.challenge);
        setLoading(false);
        return;
      }
      login(data.token, data.user);
      navigate(data.user.is_admin ? '/admin' : '/');
    } catch { setError('Connection error'); setLoading(false); }
  };

  const handle2fa = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login/verify-2fa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ challenge, code })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }
      login(data.token, data.user);
      navigate('/');
    } catch { setError('Connection error'); setLoading(false); }
  };

  if (needs2fa) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-brand"><img src="/logo3.png" alt="Retail Alpha" style={{ width: '75%', display: 'block', margin: '0 auto', objectFit: 'contain' }} /></div>
          <h2>Two-Factor Verification</h2>
          <p className="auth-subtitle">A verification code was sent to your email. Enter it below.</p>
          {error && <div className="auth-error">{error}</div>}
          <form onSubmit={handle2fa}>
            <div className="auth-field">
              <label>Verification Code</label>
              <input type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="Enter 6-digit code" maxLength={6} autoFocus />
            </div>
            <button className="auth-btn" type="submit" disabled={loading || code.length < 6}>{loading ? 'Verifying...' : 'Verify & Login'}</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/logo3.png" alt="Retail Alpha" style={{ width: '75%', display: 'block', margin: '0 auto', objectFit: 'contain' }} />
          <p style={{ color: '#64748b', fontSize: 13, margin: '8px 0 0', textAlign: 'center' }}>AI-Powered Alpha for Retail Investors</p>
        </div>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="auth-field">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required autoFocus />
          </div>
          <div className="auth-field">
            <label>Password</label>
            <PasswordInput value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your password" required />
          </div>
          <button className="auth-btn" type="submit" disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
        </form>
        <div className="auth-footer">
          <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
        </div>
      </div>
    </div>
  );
}
